<script setup lang="ts">
import { Button } from '~/components/ui/button'

defineProps<{ to: string }>()
const emit = defineEmits<{ navigate: [] }>()
</script>

<template>
  <Button as-child variant="outline-blue" size="sm" class="mt-3 w-full">
    <NuxtLink :to="to" data-cta-location="ai_chat" @click="emit('navigate')">
      {{ $t('page.credits.detail.request_form_button') }}
    </NuxtLink>
  </Button>
</template>
